import { Directive, EventEmitter, Output, AfterViewInit, ElementRef, NgZone, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

@Directive({
  selector: '[finAfterViewInit]',
  standalone: false,
})
export class AfterViewInitDirective implements AfterViewInit {
  @Output() finAfterViewInit: EventEmitter<ElementRef> = new EventEmitter<ElementRef>();

  constructor(
    private elementRef: ElementRef,
    private ngZone: NgZone,
    @Inject(PLATFORM_ID) private platform: object
  ) {}

  ngAfterViewInit(): void {
    if (isPlatformServer(this.platform)) {
      return;
    }

    setTimeout(() => {
      this.ngZone.run(() => {
        this.finAfterViewInit.emit(this.elementRef);
      });
    }, 0);
  }
}
